import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetVersionQuery, useUpdateVersionMutation } from "fond/api";
import { Maybe, PowerArchitecture } from "fond/types";

interface PowerArchitectureResult {
  powerArchitecture: PowerArchitecture | null;

  // Undefined until there is a version to save against.
  updatePowerArchitecture: ((powerArchitecture: PowerArchitecture) => Promise<void>) | undefined;
}

/** Read and write the power architecture of a version. */
export const usePowerArchitecture = (versionId: Maybe<string>): PowerArchitectureResult => {
  // we use currentData here so that we pick up pessimistic updates
  const { currentData: version } = useGetVersionQuery(versionId || skipToken);
  const [updateVersion] = useUpdateVersionMutation();

  const updatePowerArchitecture = useMemo(
    () =>
      versionId
        ? async (powerArchitecture: PowerArchitecture) => {
            await updateVersion({ ID: versionId, PowerArchitecture: powerArchitecture }).unwrap();
          }
        : undefined,
    [updateVersion, versionId]
  );

  return { powerArchitecture: version?.PowerArchitecture ?? null, updatePowerArchitecture };
};
